// PROBABLY NOT USED
// FLAGGED ON 13.03.26

/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "$";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

function disc_button(){    
  setTimeout(function () {
    $("#discout_apply").click(function(){    
      var disc = $("#CartDrawer #CartContainer .ajaxcart__footer .discount_bar input").val();
      console.log(disc);
      if(disc != ""){
        window.location.replace("/checkout?discount=" + disc);
      }else{
        $("#CartDrawer #CartContainer .ajaxcart__footer .discount_bar input").css("border-color", "red");
      }    
    }); 
  }, 1700);
}
disc_button();

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
      params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + attributeToString(note),
        dataType: 'json',
        beforeSend: function() {
          $body.trigger('beforeUpdateCartNote.ajaxCart', note);
        },
        success: function(cart) {
          if ((typeof callback) === 'function') {
            callback(cart);
          }
          else {
            ShopifyAPI.onCartUpdate(cart);
          }
          $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
        },
        error: function(XMLHttpRequest, textStatus) {
          $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        },
        complete: function(jqxhr, text) {
          $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
        }
      };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
      params = {
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery(form).serialize(),
        dataType: 'json',
        beforeSend: function(jqxhr, settings) {
          $body.trigger('beforeAddItem.ajaxCart', form);
        },
        success: function(line_item) {
          if ((typeof callback) === 'function') {
            callback(line_item, form);
          }
          else {
            ShopifyAPI.onItemAdded(line_item, form);
          }
          $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
        },
        error: function(XMLHttpRequest, textStatus) {
          if ((typeof errorCallback) === 'function') {
            errorCallback(XMLHttpRequest, textStatus);
          }
          else {
            ShopifyAPI.onError(XMLHttpRequest, textStatus);
          }
          $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
        },
        complete: function(jqxhr, text) {
          $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
        }
      };
  jQuery.ajax(params);
};

ShopifyAPI.addCollItemFromForm = function(Variantid, callback, errorCallback) {  
  var form = Variantid;
  var $body = $(document.body),
      params = {
        type: 'POST',
        url: '/cart/add.js',
        data: { 
          quantity: 1,
          id: form
        },
        dataType: 'json',
        beforeSend: function(jqxhr, settings) {
          $body.trigger('beforeAddItem.ajaxCart', form);
        },
        success: function(line_item) {
          if ((typeof callback) === 'function') {
            callback(line_item, form);
          }
          else {
            ShopifyAPI.onItemAdded(line_item, form);
          }
          $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
        },
        error: function(XMLHttpRequest, textStatus) {
          if ((typeof errorCallback) === 'function') {
            errorCallback(XMLHttpRequest, textStatus);
          }
          else {
            ShopifyAPI.onError(XMLHttpRequest, textStatus);
          }
          $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
        },
        complete: function(jqxhr, text) {
          $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
        }
      };
  jQuery.ajax(params);
};


// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
      params = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        beforeSend: function() {
          $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
        },
        success: function(cart) {
          if ((typeof callback) === 'function') {
            callback(cart);
          }
          else {
            ShopifyAPI.onCartUpdate(cart);
          }
          $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
        },
        error: function(XMLHttpRequest, textStatus) {
          $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        },
        complete: function(jqxhr, text) {
          $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
        }
      };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $CollformContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, ColformOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, nextCheckout, prevCheckout, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      CollformSelector   : '.swatch-element',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $CollformContainer = $(settings.CollformSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    ColformOverride();

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {      
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  ColformOverride = function () {

    //addCollItemFromForm
    $CollformContainer.click(function(evt) {
      evt.preventDefault();
      var ProVariantid = $(this).find('input').attr("data-variantid");

      ShopifyAPI.addCollItemFromForm(ProVariantid, itemAddedCallback, itemErrorCallback);

    });


  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    setTimeout(function(){  nextCheckout(); }, 1000);


    buildCart(cart);

  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();    
    //localStorage.removeItem("type");
    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
      .append('<p class="emptycart1">' + "Votre panier est vide." + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        type = [],
        productTags = [],
        source = $("#CartTemplate").html(),
        urlCustom = '',
        template = Handlebars.compile(source);
    let tagsAlong = [];

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      $.getJSON( "/products/"+cartItem.handle+".json", function( data ) {
        var allTags = (data.product.tags).trim().split(",");
        var tag = [];
        for(var i = 0; i < allTags.length; i++){
          tag.push(allTags[i].trim())
          productTags.push(allTags[i].trim())
        }

        if(tag.includes("stock") || tag.includes("Stock")){
          if(!type.includes("Stock")){
            type.push("Stock");
          }
        }
        if(tag.includes("reserved") || tag.includes("Reserved")){
          if(!type.includes("Reserved")){
            type.push("Reserved");
          }
        }
        if(tag.includes("accessoire") || tag.includes("Accessoire")){
          if(!type.includes("Accessoire")){
            type.push("Accessoire");
          }
        }

      });



      if(index == 0) {
        urlCustom = cartItem.id+':'+cartItem.quantity;
      } else {
        urlCustom = urlCustom+','+cartItem.id+':'+cartItem.quantity;
      }


      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        lineZero: index, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      };
      items.push(item);
    });


    setTimeout(function(){
      if(productTags.indexOf("stock") > -1 && productTags.indexOf("reserved") > -1){
        $(".reserved_product").show();
        $(".no_reserved_product").hide();
        $(".no_reserved_product_stock").hide();
      }
      else if (productTags.indexOf("reserved") > -1) {
        $(".reserved_product").show();
        $(".no_reserved_product").hide();
        $(".no_reserved_product_stock").hide();
      }
      else if (productTags.indexOf("stock") > -1){
        $(".no_reserved_product_stock").show();
        $(".no_reserved_product").hide();
        $(".reserved_product").hide();
      }
      else if(productTags.index("bradery") > -1){
        $(".reserved_product").hide();
        $(".no_reserved_product").hide();
        $(".no_reserved_product_stock").hide();
      }

    },1500)

    var cart_amount = cart.total_price / 1.2;
    var donation_amount_price = cart_amount * 0.05;
    // Gather all cart data and add to DOM
    setTimeout(function(){
      data = {
        items: items,
        note: cart.note,
        type : type,
        totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
        donation: Math.ceil(donation_amount_price / 100)/0.1,
        donation_amount: Shopify.formatMoney(donation_amount_price , settings.moneyFormat),
        //totalCartDiscount: cart.total_discount === 0 ? 0 : "Vous économisez".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
        totalCartDiscount: cart.total_discount === 0 ? 0 : Shopify.formatMoney(cart.total_discount, settings.moneyFormat),
        totalCartDiscountApplied: cart.total_discount === 0 ? false : true
      }
      $cartContainer.append(template(data));
    }, 500);


    cartCallback(cart);

    $('#CartDrawer').attr('data-url', '/cart/'+urlCustom);
    $('#formOfCart').attr('data-url', '/cart/'+urlCustom);




    $.getJSON('/cart.js', function (cart) {
      var q = cart.item_count;
      var donation = false;
      var dq = 0;
      $.each(cart.items, function(index, cartItem) {
        if(cartItem.variant_id == 39257946619966){
          donation = true;
          dq = cartItem.quantity;

        }
      })

      if(donation){ 
        setTimeout(function(){
          if(!$("input#donation").is(':checked')){$("input#donation").prop( "checked", true );}
          //           $("[data-cart-count]").text(q - dq);

          $(".dtext").show();
        },500)  
      }else{ 
        setTimeout(function(){
          $(".dtext").hide();
        },500)

      }  
    });

  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  setTimeout(function(){
    nextCheckout = function () {
      $('.next__checkout').on('click', function (e) {
        e.preventDefault();
        $('.ajaxcart').css('display', 'none');
        $('#formOfCart').css('display', 'block');
        prevCheckout();
      });


      $('#formOfCart input').on('keyup', function (e) {
        e.preventDefault();
        var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
        if(pattern.test($('#email').val()) && $('#email').val() != '' && $('#prenom').val() != '' && $('#nom').val() != '' && $('#email').val() != '' && $('#address').val() != '' && $('#ville').val() != '' && $('#pays').val() != '' && $('#code').val() != ''){
          $('.form__checkout').removeAttr('disabled');
        } else {
          $('.form__checkout').attr('disabled', 'disabled');
        }
      });


      function strNormalize(str) {
        return str.normalize('NFKD').replace(/[^\w\s.-_\/]/g, '');
      }
      var full_link = '';
      $('#formOfCart').on('submit', function(event) {
        event.preventDefault();

        $('#formOfCart').css('display', 'none');
        $('#previewOfForm').css('display', 'block');
        $('[data-name]').text($('#prenom').val() + ' ' + $('#nom').val());
        $('[data-address-1]').html($('#email').val() + ' <br>' + $('#address').val() + ' ' + $('#code').val());
        $('[data-address-2]').html($('#ville').val() + ' <br>' + $('#pays').val());
        $('[data-copy-text]').val($('#prenom').val() + ' ' + $('#nom').val() + ' ' + $('#email').val() + ' ' + $('#address').val() + ' ' + $('#ville').val() + ' ' + $('#pays').val() + ' ' + $('#code').val());

        var email = $(this).find('#email').val();
        var firstname = $(this).find('#prenom').val();
        var lastname = $(this).find('#nom').val();
        var address = $(this).find('#address').val();
        var address_supp = $(this).find('#suite').val();
        var city = $(this).find('#ville').val();
        var country = $(this).find('#pays').val();
        var zip_code = $(this).find('#code').val();

        var href = $("#CartDrawer").attr('data-url');

        if(email != '') {
          href = href.concat("?checkout[email]=" + email);

          if (firstname != '') {
            href = href.concat("&checkout[shipping_address][first_name]=" + strNormalize(firstname));
          }

          if (lastname != '') {
            href = href.concat("&checkout[shipping_address][last_name]=" + strNormalize(lastname));
          }

          if (address != '') {
            href = href.concat("&checkout[shipping_address][address1]=" + strNormalize(address));
          }

          if (address_supp != '') {
            href = href.concat("&checkout[shipping_address][address2]=" + strNormalize(address_supp));
          }

          if (city != '') {
            href = href.concat("&checkout[shipping_address][city]=" + strNormalize(city));
          }

          if (zip_code != '' && Number.isInteger(Number(zip_code))) {
            href = href.concat("&checkout[shipping_address][zip]=" + zip_code);
          }

          href = href.concat("&checkout_share=true");

          var baseUri = "/account/logout?return_url=";

          var uri = baseUri.concat(encodeURIComponent(href));

          full_link = window.location.origin.concat(uri);

          var titleShare = "";

          titleShare = "Peux-tu payer mon panier de produits sur Mister k. ? ❤️"


          $("#sym__link").val(full_link);

          $("[data-copy], #sym__link").on('click', function (e) {
            e.preventDefault();
            //           var copyText = document.querySelector("#sym__link");
            //           copyText.select();
            //           document.execCommand("copy");
            //           var textCopied = $("#sym__copy-link").data('text-copied');
            //           $("#sym__copy-link span").text(textCopied);

            var copyText = document.querySelector("#sym__link");
            copyText.select();
            document.execCommand("copy");
            var textCopied = $("#sym__copy-link").data('text-copied');
            $("#sym__copy-link span").text(textCopied);
          });

          if (navigator.share) {

            $('.js-col-mobile').show();
            // Web Share API is supported
            var shareButton = document.querySelector('.sym__share-mobile');

            shareButton.addEventListener('click', function(event) {
              navigator.share({
                title: titleShare,
                url: full_link
              }).then(function() {
                console.log('Thanks for sharing!');
              }).catch(function(error) {
                console.log(error);
              });
            });
          } else { 

            var text = titleShare+" ";
            var shareLink = window.location.origin.concat(baseUri.concat(encodeURIComponent(encodeURIComponent(href))));
            text = encodeURIComponent(text).concat(shareLink);

            var emailButton = $("#sym__share-zone .sym__buttons-zone .col.email");
            var resultEmailButton = '<div class="col email"><a target="_blank" href="mailto:?subject='+titleShare+'&amp;body='+text+'" class="sym__button--share email"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"> <g id="Group_37" data-name="Group 37" transform="translate(-1216.201 -478.675)"> <g id="Rectangle_12" data-name="Rectangle 12" transform="translate(1217.201 479.675)" fill="none" stroke="#fff" stroke-width="1"> <rect width="14" height="10" stroke="none"/> <rect x="-0.5" y="-0.5" width="15" height="11" fill="none"/> </g> <g id="Group_37-2" data-name="Group 37" transform="translate(1217 482.112)"> <path id="Path_22" data-name="Path 22" d="M1220.75,498.125l7.207,3.108,7.194-3.108" transform="translate(-1220.75 -498.125)" fill="none" stroke="#fff" stroke-width="1"/> </g> </g> </svg></a></div>'

            if (emailButton.length > 0) {
              emailButton.replaceWith(resultEmailButton)
            } else {
              $(".sym__buttons-zone").append(resultEmailButton);
            }

            var whatsappButton = $("#sym__share-zone .sym__buttons-zone .col.whatsapp");
            var resultWhatsappButton = '<div class="col whatsapp"><a target="_blank" href="https://web.whatsapp.com/send?text='+text+'" target="_blank" class="sym__button--share whatsapp"><svg xmlns="http://www.w3.org/2000/svg" width="14.727" height="14.727" viewBox="0 0 14.727 14.727"> <path id="whatsapp" d="M12.521,34.14A7.3,7.3,0,0,0,1.035,42.946L0,46.727l3.869-1.016a7.275,7.275,0,0,0,3.488.888h0A7.251,7.251,0,0,0,12.521,34.14ZM7.36,45.369a6.055,6.055,0,0,1-3.09-.845l-.22-.131-2.294.6.611-2.239-.145-.23A6.077,6.077,0,1,1,13.494,39.3,6.133,6.133,0,0,1,7.36,45.369Zm3.327-4.543c-.181-.092-1.078-.533-1.246-.592s-.289-.092-.411.092-.47.592-.579.717-.214.138-.394.046a4.963,4.963,0,0,1-2.482-2.17c-.187-.322.187-.3.536-1a.338.338,0,0,0-.016-.319c-.046-.092-.411-.989-.562-1.354s-.3-.306-.411-.312-.227-.007-.348-.007a.675.675,0,0,0-.487.227,2.049,2.049,0,0,0-.638,1.522,3.572,3.572,0,0,0,.743,1.887,8.148,8.148,0,0,0,3.116,2.755,3.568,3.568,0,0,0,2.189.457,1.868,1.868,0,0,0,1.229-.868,1.525,1.525,0,0,0,.105-.868C10.989,40.961,10.867,40.915,10.687,40.826Z" transform="translate(0 -32)" fill="#fff"/> </svg></a></div>';

            if (whatsappButton.length > 0) {
              whatsappButton.replaceWith(resultWhatsappButton);
            } else {
              $(".sym__buttons-zone").append(resultWhatsappButton);
            }

            var messengerButton = $("#sym__share-zone .sym__buttons-zone .col.messenger");
            var resultMessengerButton = '<div class="col messenger"><button class="sym__button--share messenger"><svg xmlns="http://www.w3.org/2000/svg" width="14.913" height="14.913" viewBox="0 0 14.913 14.913"> <path id="facebook-messenger" d="M7.473,32A7.2,7.2,0,0,0,0,39.233a7.069,7.069,0,0,0,2.347,5.35c.251.226.2.357.242,1.751a.6.6,0,0,0,.84.528c1.591-.7,1.611-.756,1.881-.682,4.608,1.269,9.6-1.681,9.6-6.947A7.176,7.176,0,0,0,7.473,32Zm4.487,5.566-2.2,3.475a1.123,1.123,0,0,1-1.621.3L6.4,40.033a.449.449,0,0,0-.54,0L3.5,41.82a.354.354,0,0,1-.514-.471l2.2-3.475a1.124,1.124,0,0,1,1.621-.3L8.55,38.881a.45.45,0,0,0,.54,0L11.447,37.1a.353.353,0,0,1,.513.47Z" transform="translate(0 -32)" fill="#fff"/> </svg></button></div>';

            if (messengerButton.length > 0) {
              messengerButton.replaceWith(resultMessengerButton);
            } else {
              $(".sym__buttons-zone").append(resultMessengerButton);
            }

          }

        } else {
          // Errors
        }
      });
      $('#sym__share-zone').on('click', '.sym__button--share.messenger', function() {
        FB.ui({
          method: 'send',
          link: full_link,
        });
      });
    };
  }, 1000);

  prevCheckout = function () {
    $('[data-back-form]').on('click', function (e) {
      e.preventDefault();
      $('#formOfCart').css('display', 'block');
      $('#previewOfForm').css('display', 'none');
    });
    $('[data-back-cart]').on('click', function (e) {
      e.preventDefault();
      $('.ajaxcart').css('display', 'block');
      $('#formOfCart').css('display', 'none');
    });
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-remove', function(e) {            
      setTimeout(function(){
        $("#CartDrawer").addClass("loading_cart");
        disc_button();
      }, 700);
      e.preventDefault();
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.data('qty'));
      if (line) {        
        updateQuantity(line, qty);
      }
      setTimeout(function(){         
        $.getJSON('/cart.js', function (item){ $("#CartCount .cartcount").text(item.item_count); });
        $("#CartDrawer").removeClass("loading_cart");
      }, 1500);
    });
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      $("#CartDrawer").addClass("loading_cart");
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }

      setTimeout(function(){ 
        $.getJSON('/cart.js', function (item){ $("#CartCount .cartcount").text(item.item_count); });
        $("#CartDrawer").removeClass("loading_cart");
      }, 3000);

    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      $("#CartDrawer").addClass("loading_cart");
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }

      setTimeout(function(){ 
        $.getJSON('/cart.js', function (item){ $("#CartCount .cartcount").text(item.item_count); });
        $("#CartDrawer").removeClass("loading_cart");
      }, 3000);
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {         
      $("#CartDrawer").addClass("loading_cart");
      if (isUpdating) {
        evt.preventDefault();
      }
      setTimeout(function(){ 
        $.getJSON('/cart.js', function (item){ $("#CartCount .cartcount").text(item.item_count); });
        $("#CartDrawer").removeClass("loading_cart");
      }, 3000);
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {

      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      //       numInputs.each(function() {
      //         var $el = $(this),
      //             currentQty = $el.val(),
      //             inputName = $el.attr('name'),
      //             inputId = $el.attr('id');

      //         var itemAdd = currentQty + 1,
      //             itemMinus = currentQty - 1,
      //             itemQty = currentQty;

      //         var source   = $("#JsQty").html(),
      //             template = Handlebars.compile(source),
      //             data = {
      //               key: $el.data('id'),
      //               itemQty: itemQty,
      //               itemAdd: itemAdd,
      //               itemMinus: itemMinus,
      //               inputName: inputName,
      //               inputId: inputId
      //             };

      //         // Append new quantity selector then remove original
      //         $el.after(template(data)).remove();
      //       });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));


$("#donation").on("click",function(){
  console.log("CLICKED");
  console.log("checkbox"+$(this).val());
});


// $(document).on("click",'.next__checkout',function(){
//   // e.preventDefault();
//   $('.ajaxcart').css('display', 'none');
//   $('#formOfCart').css('display', 'block');
//   //prevCheckout();
// });


// $(document).on("click", '[data-back-form]', function() {
//   //e.preventDefault();
//   $('#formOfCart').css('display', 'block');
//   $('#previewOfForm').css('display', 'none');
// });

// $(document).on("click", '[data-back-cart]', function() {

//  // e.preventDefault();
//   $('.ajaxcart').css('display', 'block');
//   $('#formOfCart').css('display', 'none');
// });

jQuery(document).ready(function($){
  setInterval(function () {    
    var tprice = $(".side_cart_total .money").text();
    if(tprice){
      tprice = tprice.replace("€", "");
      if(tprice < 200){
        var rtprice = (200 - tprice) + "€";
        $(".shipping_text").html("Plus que " + "<span id='shippings'>" + rtprice + "</span> pour la livraison gratuite");
      }else{
        $(".shipping_text").html("Vous bénéficiez de la livraison gratuite !");
      }
    }
  }, 500);


  $(".site-header__cart-toggle, .product-form__cart-submit").click(function(){    
    disc_button();
  });


});
















